import { createFileRoute, Outlet } from "@tanstack/react-router";
import { EmployeeLayout } from "@/components/employee/EmployeeLayout";
import { pageHead } from "@/lib/seo";
import { setLocale } from "@/paraglide/runtime";

export const Route = createFileRoute("/_authenticated/employee")({
  head: () =>
    pageHead({
      title: "Staff | Mark Egly Golf",
      description: "Staff schedule for Mark Egly Golf.",
      path: "/employee",
      noindex: true,
    }),
  beforeLoad: () => {
    void setLocale("en", { reload: false });
  },
  component: EmployeeRouteLayout,
});

function EmployeeRouteLayout() {
  return (
    <EmployeeLayout>
      <Outlet />
    </EmployeeLayout>
  );
}
